// extracted by mini-css-extract-plugin
module.exports = {"icon":"ResetIcon__icon___1HGYl"};